var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isOverdue)?_c('Tag',{attrs:{"type":"error"}},[_vm._v(" "+_vm._s(_vm.$t('common.overdue'))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }